import { render, staticRenderFns } from "./BusinessResponse.vue?vue&type=template&id=b17e3786&"
import script from "./BusinessResponse.vue?vue&type=script&lang=js&"
export * from "./BusinessResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports